export default __webpack_public_path__ + "static/media/5ee847d877add222e050e6ebc5efd6e8.svg";